module.exports = __webpack_public_path__ + "static/batman-logo-e47afe1635ccce40f43a61321c80454f.png";